var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('div',{staticStyle:{"max-width":"200px"}},[_c('svg',{attrs:{"id":_vm.div_id}})])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }